import React, {Component} from 'react';
import axios from 'axios';
import './Wallettrans.css';
import Breadcrumbs from '../Components/Breadcrumbs';
class Wallettrans extends React.Component {
    constructor(props){
        super(props);
            
}
  render() {
    return <div>
<div class="container">
{/* <nav aria-label="breadcrumb">
            <ol class="breadcrumb2 breadcrumb">
                <li class="breadcrumb"><a href="index.html"> Home&nbsp; </a></li>
                <li class="breadcrumb"> / My Wallet </li>
            </ol>
        </nav> */}
    <div class="row">
    <Breadcrumbs title="Wallet Transaction" bc="wallet Transaction"/>
        <div class="col-md-4 mt-3">
            <h2><a href="/my-wallet" type="button"></a>Wallet</h2>
        </div>
        <div class=" col-md-4 mt-4">
        <p class="manage">You can manage your past orders here</p>
                    <h6  class="small-header">For the month of</h6>
                    
					
							
								<form class="form-inline">
									<div class="stepper-widget">
										<div class="">
										    <select className="form-controls header-space ">
										    <option value="">January</option>
										    <option value="">February</option>
                                            <option value="">March</option>
                                            <option value="">April</option>
										    <option value="">May</option>
                                            <option value="">June</option>
                                            <option value="">July</option>
                                            <option value="">August</option>
                                            <option value="">September</option>
                                            <option value="">October</option>
                                            <option value="">November</option>
                                            <option value="">December</option>
										    </select>
									    </div>
							        </div>
								</form>
                          <div class=" bottom-space bottom-line ">
                                            <span class="float-right ">Rs  120</span>
                                           
                        
                                              <h6 class="opacity-header">{/* <Moment format="DD MMMM yyyy" withTitle>{itm.posting_date}</Moment> */}</h6>
                                                  <h6 class="purchase ">Purchase </h6>
                                                  <h6 class="Delivered ">Transaction successful</h6>
                                          </div>		
                
               
                    
                                                           
                    
                   
                    {/* <div class=" bottom-space bottom-line ">
                  <span class="float-right ">0</span>
              
                    <h6 class="opacity-header">01 september 2020</h6>
                        <h6 class="purchase "> purchase</h6>
                        <h6 class="transaction-failed ">Transaction Failed-Insuffient Balance</h6>
                    </div> */}
                    
                </div>
            </div>
        </div>
    </div>
    }
}

export default Wallettrans;